import React from 'react';
import WebRoutes from './WebRoutes';

const WebApp = () => {
    return (
        <div className="web-app">
            <WebRoutes />
        </div>
    );
};

export default WebApp;
